<template>
  <router-view />
</template>
<script setup>
import { onMounted } from 'vue'
import { useQuasar } from 'quasar'
import { mergeMessages } from 'boot/i18n'
import { useConfiguration } from './composables/useConfiguration.pinia'
import { useCustomStylesheet } from '@wilken/portal-ui-common/composables/useCustomStylesheet'
import { useCustomIcons } from '@wilken/portal-ui-common/composables/useCustomIcons'
import { showTotalErrorPage } from './helpers/errorHelper'

const $q = useQuasar()
const { brandConfig } = useConfiguration()
const { iconMapFn } = useCustomIcons({ config: brandConfig.value, loadIcons: true })

const handleStylesheetError = (errEvent) => {
  const err = new Error('Brand styles failed to load')
  err.event = errEvent
  console.error(err)

  showTotalErrorPage('generic', {})
}

useCustomStylesheet({
  href: '/__publicPath__/resources/css/style.css',
  onloadFn: () => window.onResourcesLoaded(),
  onErrorFn: handleStylesheetError
})

$q.iconMapFn = iconMapFn

onMounted(() => {
  const tenantI18n = brandConfig.value.i18n || {}
  mergeMessages(tenantI18n)
})
</script>
